<template
  ><div>
      <v-label ><b>{{label}}</b></v-label>
    <s-select-generic
      ref="generic"
      autocomplete  class="text"
      itemtext="GenDescription"
      itemvalue="GenID"
      id="GenDescription"
      :value="value"
      @input="input($event)"
      @change="change($event)"
      :config="config"
      :full="full"
      :text="text" :clearable=clearable :noDefault=noDefault
      :disabled="disabled"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sGenericService from "./../../services/General/GenericService";
export default {
  name: "SelectPosition",
  components: {},
  props: {
     clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    AreID: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    AreID(newVal) {
      // Actualizar el parámetro cuando cambie el área
      if (this.config && this.config.params) {
        this.config = {
          ...this.config,
          params: {
            ...this.config.params,
            AreID: newVal || 0,
          },
        };
      }
    },
  },
  methods: {
    focus() {
      let refGeneric = Array.isArray(this.$refs.generic) ? this.$refs.generic[0] : this.$refs.generic;
      if (refGeneric && typeof refGeneric.focus === 'function') {
        refGeneric.focus();
      }
    },
    error(msg) {
      let refGeneric = Array.isArray(this.$refs.generic) ? this.$refs.generic[0] : this.$refs.generic;
      if (refGeneric && typeof refGeneric.error === 'function') {
        refGeneric.error(msg);
      }
    },
    input(val) {
      this.$emit("input", val);
    },
    change(item) {
      //console.log("change", item);
      this.$emit("change", item);
    },
  },
    data: () => ({
        item: 0,
        val:'',
        items: [],
        config: {},
    }),
  
    created() {
        this.config = {
            url:_sGenericService.getUrlPosition(),
            title: this.label,
                params: {search:'', requestID:this.$fun.getUserID(), AreID: this.AreID }
        }
       

    }

  }

</script>
